// 飞行操作
export default {
    time: '时间',
    deviceName: '设备名称',
    deviceSN: '设备SN',
    operationContent: '操作内容',
    operationUser: '操作用户',
}